import client from './client'
import type { PortalOrganization } from '@/types/portal'

export function list() {
  return client.get<PortalOrganization[]>('/portal/organizations')
}
